var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5004 36.0144C29.9645 36.0144 36.0154 29.9635 36.0154 22.4994C36.0154 15.0352 29.9645 8.98438 22.5004 8.98438C15.0362 8.98438 8.98535 15.0352 8.98535 22.4994C8.98535 29.9635 15.0362 36.0144 22.5004 36.0144Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.375H18C17.385 21.375 16.875 20.865 16.875 20.25C16.875 19.635 17.385 19.125 18 19.125H27C27.615 19.125 28.125 19.635 28.125 20.25C28.125 20.865 27.615 21.375 27 21.375Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.875H18C17.385 25.875 16.875 25.365 16.875 24.75C16.875 24.135 17.385 23.625 18 23.625H22.5C23.115 23.625 23.625 24.135 23.625 24.75C23.625 25.365 23.115 25.875 22.5 25.875Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9851 34.425C38.4901 33.51 37.4401 33 36.0301 33C34.9651 33 34.0501 33.435 33.5101 34.185C32.9701 34.935 32.8501 35.94 33.1801 36.945C33.8251 38.895 34.9501 39.33 35.5651 39.405C35.6551 39.42 35.7451 39.42 35.8501 39.42C36.5101 39.42 37.5301 39.135 38.5201 37.65C39.3151 36.495 39.4651 35.34 38.9851 34.425Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStatus);
export default __webpack_public_path__ + "static/media/searchStatus.6bbfeef464b3b81126dc43145e59b0f0.svg";
export { ForwardRef as ReactComponent };